import React from 'react'
import { Route } from 'react-router'
import { element, string } from 'prop-types'

const FlowStep = ({ name, children }) => (
  <Route path={`/${name}`} render={() => children} />
)

FlowStep.propTypes = {
  name: string.isRequired,
  children: element.isRequired
}

export default FlowStep
